import { Observable } from 'rxjs';
import { createAction, Store } from '@ngrx/store';
import { Renderer2 } from '@angular/core';

import { storageActions } from './storage';

export const debugAction = (msg: string) => createAction(`[DEBUG] ${ msg }`);

export const syncStore = (store: Store<any>, renderer: Renderer2): Observable<void> => {
  const dispose = renderer.listen('window', 'storage', ({ key }: { key: string }) =>
    store.dispatch(storageActions.changed({ key })),
  );

  return new Observable(() => dispose);
};
